import { useTranslation } from "react-i18next";
import { FileUploadCard } from "components/common/FileUploadCard";
import type { FileCategoryCardsGridProps } from "./types";

const ACCEPTED_FILE_TYPES = [".pdf"];

export const FileCategoryCardsGrid = ({
  selectedFiles,
  setters,
}: FileCategoryCardsGridProps) => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full">
      <FileUploadCard
        title={t("smartSurveyor.floorPlans.title")}
        description={t("smartSurveyor.floorPlans.description")}
        acceptedFileTypes={ACCEPTED_FILE_TYPES}
        value={selectedFiles.floorPlans}
        onFileSelect={setters.floorPlans}
        multiple
      />
      <FileUploadCard
        title={t("smartSurveyor.electricalLineDiagrams.title")}
        description={t("smartSurveyor.electricalLineDiagrams.description")}
        acceptedFileTypes={ACCEPTED_FILE_TYPES}
        value={selectedFiles.electricalDiagrams}
        onFileSelect={setters.electricalDiagrams}
        multiple
      />
      <FileUploadCard
        title={t("smartSurveyor.billOfQuantities.title")}
        description={t("smartSurveyor.billOfQuantities.description")}
        acceptedFileTypes={ACCEPTED_FILE_TYPES}
        value={selectedFiles.billOfQuantities}
        onFileSelect={setters.billOfQuantities}
      />
      <FileUploadCard
        title={t("smartSurveyor.otherFiles.title")}
        description={t("smartSurveyor.otherFiles.description")}
        acceptedFileTypes={ACCEPTED_FILE_TYPES}
        value={selectedFiles.otherFiles}
        onFileSelect={setters.otherFiles}
        multiple
      />
    </div>
  );
};
